import {
  Box, Typography, Button, Chip, Alert, Container,
  IconButton, Pagination, Badge, FormControl, Select, MenuItem,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import { CircularProgress } from "@mui/material";
import ListView from "./ListView";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import TuneIcon from "@mui/icons-material/Tune";
import SortIcon from "@mui/icons-material/Sort";
import PetsIcon from "@mui/icons-material/Pets";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import { connect } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import ServiceCardListing from "../../components/serviceListings/ServiceCardListing";
import * as Actions from "../../redux/actions";
import HomeCategories from "../../components/home/HomeCategories";
import FilterModal from "../listing/FilterModal";

const ServicesPageListings = ({
  services,
  subServices,
  loadServices,
  loadServiceListings,
  serviceListing,
  jwtToken,
  totalServiceListing,
  servicesLoading,
  error,
}) => {
  const { serviceId, subServiceId, sellerId, categoryId } = useParams();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [filters, setFilter] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage] = useState(25);
  const [view, setView] = useState("Grid");
  const [sortBy, setSortBy] = useState("newest");
  const [snackbarStates, setSnackbarStates] = useState({ open: false, message: "", severity: "" });

  const store_id = sellerId || "";
  const service_id = serviceId || "";
  const sub_service_id = subServiceId || "";
  const category_id = categoryId || "";
  const queryParams = new URLSearchParams(location.search);
  const is_Featured = queryParams.get("is_featured");

  useEffect(() => {
    if (error !== "") setSnackbarStates({ open: true, message: error, severity: "error" });
  }, [error]);

  useEffect(() => {
    loadServiceListings({ service_id, sub_service_id, store_id, category_id, jwtToken, is_Featured, pageNumber, rowsPerPage });
  }, [services, subServices, categoryId, serviceId, is_Featured, subServiceId, sellerId]);

  useEffect(() => {
    if (services) loadServices();
  }, []);

  const sortedListings = useMemo(() => {
    if (!serviceListing) return [];
    const sorted = [...serviceListing];
    switch (sortBy) {
      case "price_low": return sorted.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
      case "price_high": return sorted.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
      case "name_az": return sorted.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      default: return sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }
  }, [serviceListing, sortBy]);

  const totalPages = Math.ceil((totalServiceListing || 0) / rowsPerPage);
  const activeFilterCount = filters.length;

  return (
    <>
      <Snackbar open={snackbarStates.open} autoHideDuration={3000} onClose={() => setSnackbarStates((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert onClose={() => setSnackbarStates((s) => ({ ...s, open: false }))} variant="filled" severity={snackbarStates.severity} sx={{ width: "100%" }}>
          {snackbarStates.message}
        </Alert>
      </Snackbar>

      <FilterModal open={open} setOpen={setOpen} setFilter={setFilter} page="Services" />

      <Box sx={{ minHeight: "100vh", backgroundColor: "#111" }}>

        {/* ── Hero header ── */}
        <Box sx={{ position: "relative", background: "linear-gradient(to bottom, #1a1a1a 0%, #111 100%)", borderBottom: "1px solid #222", py: { xs: 4, md: 5 }, overflow: "hidden" }}>
          <Box sx={{ position: "absolute", inset: 0, background: "radial-gradient(ellipse at 50% 0%, rgba(255,192,1,0.07) 0%, transparent 70%)", pointerEvents: "none" }} />
          <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
            {/* Breadcrumb */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <Typography component={Link} to="/" sx={{ color: "#777", fontSize: "13px", textDecoration: "none", "&:hover": { color: "#FFC001" } }}>Home</Typography>
              <Typography sx={{ color: "#555", fontSize: "13px" }}>/</Typography>
              <Typography sx={{ color: "#FFC001", fontSize: "13px", fontWeight: 600 }}>Listings</Typography>
            </Box>
            <Typography sx={{ fontWeight: 800, fontSize: { xs: "26px", md: "36px" }, color: "#fff", lineHeight: 1.1 }}>
              Browse <Box component="span" sx={{ color: "#FFC001" }}>Listings</Box>
            </Typography>
            <Typography sx={{ color: "#777", fontSize: "13px", mt: 0.5 }}>
              {totalServiceListing ? `${totalServiceListing.toLocaleString()} listings available` : "Browse all available listings"}
            </Typography>
          </Container>
        </Box>

        {/* ── Animals / Services sticky tab bar ── */}
        <Box sx={{ position: "sticky", top: 0, zIndex: 100, backgroundColor: "#0d0d0d", borderBottom: "1px solid #1e1e1e" }}>
          <Container maxWidth="xl">
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                onClick={() => navigate("/listings")}
                sx={{
                  display: "flex", alignItems: "center", gap: 1,
                  px: 3, py: 1.6, cursor: "pointer",
                  borderBottom: "2px solid transparent",
                  transition: "all 0.2s ease",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.03)" },
                }}
              >
                <PetsIcon sx={{ fontSize: 17, color: "#666" }} />
                <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#666" }}>Animals</Typography>
              </Box>
              <Box
                onClick={() => navigate("/services/listings")}
                sx={{
                  display: "flex", alignItems: "center", gap: 1,
                  px: 3, py: 1.6, cursor: "pointer",
                  borderBottom: "2px solid #FFC001",
                  transition: "all 0.2s ease",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.03)" },
                }}
              >
                <MiscellaneousServicesIcon sx={{ fontSize: 17, color: "#FFC001" }} />
                <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#FFC001" }}>Services</Typography>
              </Box>
            </Box>
          </Container>
        </Box>

        {/* ── Category carousel ── */}
        <Box sx={{ backgroundColor: "#111", borderBottom: "1px solid #1a1a1a" }}>
          <Container maxWidth="xl" sx={{ pt: 2, pb: 0.5 }}>
            <Typography sx={{ color: "#555", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", mb: 1 }}>
              Browse by Category
            </Typography>
          </Container>
          <HomeCategories classes={services} page="Services" />
        </Box>

        {/* ── Toolbar ── */}
        <Box sx={{ backgroundColor: "#0d0d0d", borderBottom: "1px solid #1a1a1a", py: 1.2 }}>
          <Container maxWidth="xl">
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>

              {/* Left: count + chips */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                {totalServiceListing > 0 && (
                  <Typography sx={{ color: "#555", fontSize: "13px", fontWeight: 600 }}>
                    {sortedListings.length} shown
                  </Typography>
                )}
                {filters.map((tag, i) => (
                  <Chip key={i} label={tag} size="small"
                    sx={{ backgroundColor: "rgba(255,192,1,0.12)", color: "#FFC001", border: "1px solid rgba(255,192,1,0.3)", fontSize: "12px", height: 24 }} />
                ))}
              </Box>

              {/* Right: sort + view + filter */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <FormControl size="small">
                  <Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    startAdornment={<SortIcon sx={{ color: "#888", mr: 0.5, fontSize: 15 }} />}
                    sx={{
                      color: "#ccc", fontSize: "13px", height: "34px", minWidth: 155,
                      backgroundColor: "#1a1a1a",
                      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#2a2a2a" },
                      "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#FFC001" },
                      "& .MuiSvgIcon-root": { color: "#888" },
                    }}
                  >
                    <MenuItem value="newest">Newest First</MenuItem>
                    <MenuItem value="price_low">Price: Low → High</MenuItem>
                    <MenuItem value="price_high">Price: High → Low</MenuItem>
                    <MenuItem value="name_az">Name: A – Z</MenuItem>
                  </Select>
                </FormControl>

                <Box sx={{ display: "flex", backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "8px", overflow: "hidden" }}>
                  <IconButton onClick={() => setView("Grid")} size="small" sx={{ borderRadius: 0, px: 1, backgroundColor: view === "Grid" ? "#FFC001" : "transparent", "&:hover": { backgroundColor: view === "Grid" ? "#e6ac00" : "#222" } }}>
                    <GridViewIcon sx={{ color: view === "Grid" ? "#000" : "#777", fontSize: 17 }} />
                  </IconButton>
                  <IconButton onClick={() => setView("List")} size="small" sx={{ borderRadius: 0, px: 1, backgroundColor: view === "List" ? "#FFC001" : "transparent", "&:hover": { backgroundColor: view === "List" ? "#e6ac00" : "#222" } }}>
                    <ListIcon sx={{ color: view === "List" ? "#000" : "#777", fontSize: 17 }} />
                  </IconButton>
                </Box>

                <Badge badgeContent={activeFilterCount} color="warning" sx={{ "& .MuiBadge-badge": { backgroundColor: "#FFC001", color: "#000", fontWeight: 700, fontSize: "10px" } }}>
                  <Button
                    variant={activeFilterCount > 0 ? "contained" : "outlined"}
                    startIcon={<TuneIcon sx={{ fontSize: "16px !important" }} />}
                    onClick={() => setOpen(true)}
                    sx={{
                      height: "34px",
                      backgroundColor: activeFilterCount > 0 ? "#FFC001" : "transparent",
                      borderColor: activeFilterCount > 0 ? "#FFC001" : "#2a2a2a",
                      color: activeFilterCount > 0 ? "#000" : "#ccc",
                      fontWeight: 700, fontSize: "13px", textTransform: "none", borderRadius: "8px", px: 1.8,
                      "&:hover": { backgroundColor: "#FFC001", borderColor: "#FFC001", color: "#000" },
                    }}
                  >
                    Filter
                  </Button>
                </Badge>
              </Box>
            </Box>
          </Container>
        </Box>

        {/* ── Listings ── */}
        <Container maxWidth="xl" sx={{ py: { xs: 3, md: 4 }, pb: 6 }}>
          {servicesLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
              <CircularProgress sx={{ color: "#FFC001" }} />
            </Box>
          ) : sortedListings.length === 0 ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 10, gap: 2 }}>
              <MiscellaneousServicesIcon sx={{ color: "#333", fontSize: 56 }} />
              <Typography sx={{ color: "#555", fontSize: "15px" }}>No listings found</Typography>
              {activeFilterCount > 0 && (
                <Button onClick={() => setFilter([])}
                  sx={{ color: "#FFC001", border: "1px solid rgba(255,192,1,0.3)", borderRadius: "8px", px: 3, py: 0.8, textTransform: "none", fontSize: "13px", "&:hover": { backgroundColor: "rgba(255,192,1,0.08)" } }}>
                  Clear filters
                </Button>
              )}
            </Box>
          ) : view === "Grid" ? (
            <ServiceCardListing listData={sortedListings} classes={services} />
          ) : (
            <ListView listData={sortedListings} services={services} />
          )}

          {totalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
              <Pagination
                count={totalPages}
                page={pageNumber + 1}
                onChange={(_, val) => { setPageNumber(val - 1); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                variant="outlined"
                shape="rounded"
                sx={{
                  "& .MuiPaginationItem-root": { color: "#777", borderColor: "#333" },
                  "& .MuiPaginationItem-root.Mui-selected": { backgroundColor: "#FFC001", color: "#000", fontWeight: 700, borderColor: "#FFC001" },
                  "& .MuiPaginationItem-root:hover": { borderColor: "#FFC001", color: "#FFC001" },
                }}
              />
            </Box>
          )}
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = ({ Services, Listings, Auth }) => ({
  subServices: Services.subServices,
  services: Services.services,
  serviceListing: Listings.serviceListing,
  jwtToken: Auth.jwtToken,
  servicesLoading: Listings.servicesLoading,
  totalServiceListing: Listings.totalServiceListing,
  error: Listings.errorServices,
});

const mapDispatchToProps = (dispatch) => ({
  loadServices: () => dispatch(Actions.thunkLoadServices()),
  loadServiceListings: ({ service_id, sub_service_id, store_id, category_id, is_Featured, jwtToken, pageNumber, rowsPerPage }) =>
    dispatch(Actions.thunkLoadServiceListings({ service_id, sub_service_id, store_id, is_Featured, category_id, jwtToken, pageNumber, rowsPerPage })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ServicesPageListings);
